import { useMemo } from "react";

export function useWordCloud(
  words: string[],
  topWords = 0,
  stopWords = ["at", "by", "of", "to"]
) {
  const dict = useMemo(
    () => removeStopWords(words, stopWords),
    [words, stopWords]
  );
  return useMemo(() => createWordCloud(dict, topWords, []), [dict, topWords]);
}

export function createWordCloud(
  words: string[],
  topWords = 0,
  stopWords = ["at", "by", "of", "to"]
) {
  const dict = removeStopWords(words, stopWords);
  const minMap = new Map<string, number>();
  const countMap = new Map<string, number>();
  for (const word of dict) {
    const count = (countMap.get(word) || 0) + 1;
    countMap.set(word, count);
    if (count >= 2) minMap.set(word, count);
  }
  const clone = [...minMap];
  if (topWords) {
    clone.sort(([_1, l1], [_2, l2]) => l2 - l1);
    while (clone.length > topWords) {
      clone.pop();
    }
  }
  return clone.sort(([w1], [w2]) =>
    w1.toLowerCase().localeCompare(w2.toLowerCase())
  );
}

function removeStopWords(words: string[], stop?: string[]) {
  return Array.isArray(stop) && stop.length > 1
    ? words.filter((word) => !stop.includes(word.toLowerCase()))
    : words;
}
